const Colors = Object.freeze({
  screenBackground: '#06001F',
  modalBackground: 'rgba(6, 0, 31, 0.75)',
  buttonTop: 'rgba(217, 217, 217, 0.15)',
  buttonBottom: '#25203A',
  lightGray: '#D9D9D9',
  gray: '#808080',
  pressedButton: 'rgba(217, 217, 217, 0.35)',
  bannerText: '#D17D00',
  confirmationButton: 'rgba(209, 125, 0, 0.6)',
  confirmationButtonHighlight: 'rgba(209, 125, 0, 0.8)',
  transparent: 'rgba(0, 0, 0, 0)',
});

export default Colors;
